module.exports = {
  projectName: process.env.VUE_APP_NAME,
  tokenName: 'X-TOKEN',
  // 最多可显示的标签个数
  maxTabs: 9,
  // 路由白名单
  routesWhiteList: ['/login', '/401', '/404', '*', '/'],
  // 监听页面内容改变
  listeningPageChangeRouteNames: [],
  // 需要 keep-alive 的页面
  keepAliveRoutes: ['CashierReturnAdd', 'OriginalOrderReturn', 'Cashier', 'NewCashier', 'SettingsPriceTag','GoodsInfo'],
  // 不需要 layout 容器的页面，此配置用在 layout 容器中 v-if 判断
  noLayoutRoutes: ['searchMember'],
  // 权限标记
  permissionTag: 'pos',
}
